/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */


import { Paragraph, Table } from 'docx';
import { heading, pagebreak, Styles } from './document-structure';

interface AppendixItem {
  heading: string;
  name: string,
  content: Table | Paragraph
}

type SupportedOutput = Paragraph | Table;

type headingFunc = (text: string, styles?: Styles) => Paragraph;

export class AppendixGenerator {

  constructor(
    private headingFn: headingFunc = heading,
    private style?: Styles,
  ) {
  }
  private appendices = new Map<string, AppendixItem>();


  add(name: string, content: SupportedOutput) {
    const appendix = this.appendices.get(name);
    if (appendix) {
      return appendix.heading;
    }

    const heading = `Appendix ${this.appendices.size + 1}: ${name}`;
    this.appendices.set(name, { heading, name, content });
    return heading;
  }

  render() {
    const output: SupportedOutput[] = [];
    this.appendices.forEach((a, i) => (
      output.push(pagebreak(), this.headingFn(a.heading, this.style), a.content)
    ));
    return output;
  }
}

